module.exports = __webpack_public_path__ + "media/flags/cx-15a4d044.svg";